import { Button, Layout } from "antd";
import { GeneralStore } from "../stores";
import { MainSidebarItems } from "../sharedComponents";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
const { Sider } = Layout;

export const Sidebar = () => {
 const { sidebarCollapsed, setSidebarCollapsed } = GeneralStore();

 return (
   <Sider
     className="!h-[calc(100vh-16px)] !max-h-[calc(100vh-16px)] !min-h-[calc(100vh-16px)] my-2 ml-2 overflow-hidden hidden md:block sm:sticky flex-col justify-between top-2 rounded-lg border border-gray-200"
     breakpoint="lg"
     collapsedWidth="60"
     collapsible
     collapsed={sidebarCollapsed}
     trigger={null}
   >
     <div className="h-full flex flex-col justify-between">
       <div
         style={{ scrollbarWidth: "none" }}
         className="overflow-y-scroll scrollbar-hide "
       >
         <MainSidebarItems />
       </div>
       <Button
         size="large"
         className="p-4 !rounded-none flex items-center justify-center"
         type="text"
         onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
       >
         {sidebarCollapsed ? (
           <DoubleRightOutlined size={40} />
         ) : (
           <DoubleLeftOutlined size={40} />
         )}
       </Button>
     </div>
   </Sider>
 );
};
